<template>
  <div class="col-md-12">
    <div class="row group-item align-items-center">
      <div class="col-md-8" @click.stop="onClickGroupItem">
        <div class="row justify-content-center flex-column">
          <p class="typo-heading16 typo-mediym group-title mb-1">{{ group.name }}</p>
          <p class="typo-paragraph12 typo-regular">{{$t("generals.lastModified")}} {{ timeago }}</p>
        </div>
      </div>
      <div class="col-md-3" @click.stop="onClickGroupItem">
        <div class="row">
          <p class="typo-paragraph12 typo-regular ml-1">{{ $t("group.containTemplate", { number: group.count, template: $tc("generals.templateLower", group.count|1) }) }}</p>
        </div>
      </div>
      <div class="col-md-1">
        <div class="row">
          <GroupSettingsDropdown @onUngroupSuccess="onUngroupSuccess" :pageType="pageType" :group="group" :disableUngroup="disableUngroup" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupSettingsDropdown from "./GroupSettingsDropdown";
import { TimeMaker } from "@/plugins";
import { mapState, mapGetters } from "vuex";
export default {
  name: "GroupItem",
  components: {
    GroupSettingsDropdown
  },
  props: {
    group: Object,
    pageType: String
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    ...mapGetters("page", {
      sortedSubPages: "sortedSubPages",
      sortedArticlePages: "sortedArticlePages",
      sortedCollectionPages: "sortedCollectionPages",
      sortedHomePages: "sortedHomePages",
      sortedProductPages: "sortedProductPages"
    }),
    currentTypePages() {
      switch (this.pageType) {
        case "subpages":
          return this.sortedSubPages;
        case "articlepages":
          return this.sortedArticlePages;
        case "collectionpages":
          return this.sortedCollectionPages;
        case "productpages":
          return this.sortedProductPages;
        case "homepages":
          return this.sortedHomePages;
        default:
          return this.sortedHomePages;
      }
    },
    timeago() {
      return new TimeMaker(this.group.updated_at).ago(this.language);
    },
    disableUngroup() {
      let childItems = this.currentTypePages.filter(item => {
        if (item.page_group_id && item.page_group_id == this.group.id) {
          return item;
        }
      });
      return !childItems || !childItems.length;
    }
  },
  methods: {
    itemClick(fn) {
      if (this.$refs.moreAction) {
        this.$refs.moreAction.toggleDropdown();
      }
      if (fn) fn();
    },
    onClickGroupItem() {
      this.$emit("onClickGroupItem", this.group);
    },
    onUngroupSuccess() {
      this.$emit("onUngroupSuccess");
    }
  }
};
</script>

<style lang="scss" scoped>
.group-item {
  @include trans-all;
  // padding: 19px 16px 19px 24px;
  border-radius: $radius;
  margin-bottom: 24px;
  position: relative;
  cursor: pointer;
  background: $neutral5;

  &:hover {
    @include trans-all;
    box-shadow: 0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14), 0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064), 0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455), 0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07), 0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545), 0px 12px 38px rgba(34, 34, 34, 0.0393604);
  }

  & > div > div {
    padding: 19px 24px;
  }

  .group-title {
    width: 360px;

    @media (max-width: 1440px) {
      width: 300px;
    }

    @media (max-width: 1024px) {
      width: 200px;
    }

    color: $cSecondary4;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }

  ::v-deep .gp_dropdown-button {
    width: 40px;
    height: 40px;
    border-radius: $radius;
  }

  ::v-deep .gp_dropdown_list {
    width: 228px;
  }

  .total {
    color: $black1;
  }
}
</style>
